import { render, staticRenderFns } from "./DebtorReceiptListView.vue?vue&type=template&id=15d0294e"
import script from "./DebtorReceiptListView.vue?vue&type=script&lang=js"
export * from "./DebtorReceiptListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d0294e')) {
      api.createRecord('15d0294e', component.options)
    } else {
      api.reload('15d0294e', component.options)
    }
    module.hot.accept("./DebtorReceiptListView.vue?vue&type=template&id=15d0294e", function () {
      api.rerender('15d0294e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtorreceipt/DebtorReceiptListView.vue"
export default component.exports